// 通用业务接口 HTTP 请求方法封装
import request from './request'

const http = {
  get (url, params, headers, responseType) {
    const config = {
      method: 'GET',
      url: url,
      params: params || {},
      headers: headers || {},
      responseType: responseType || null
    }
    return request(config)
  },
  post (url, data, headers) {
    const config = {
      method: 'POST',
      url: url,
      data: data || {},
      headers: headers || {}
    }
    return request(config)
  },
  delete (url, params, headers) {
    const config = {
      method: 'DELETE',
      url: url,
      params: params || {},
      headers: headers || {}
    }
    return request(config)
  }
}

export default http
